import React from 'react';
import './RegistrationSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const RegistrationCard = ({ title, description, image, index }) => {
  const cardRef = useScrollAnimation(index * 200);
  
  return (
    <div ref={cardRef} className="registration-card animate-on-scroll animate-fade-in-up">
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">
          {description}
        </p>
      </div>
      <div className="card-image">
        <img src={image} alt={title} className="registration-img" />
      </div>
    </div>
  );
};

const RegistrationSection = () => {
  const registrationData = [
    {
      title: "تسجيل مزودي الخدمات",
      description: "حياك انضم وكن ضمن نخبة من مزودي الخدمات في منصة فتل",
      image: "/p1.png"
    },
    {
      title: "تسجيل صاحب مشروع",
      description: "حياك انضم لمنصة فتل واحصل على دعم مزودي الخدمات التسويقية",
      image: "/p2.png"
    }
  ];

  return (
    <section id="registration-section" className="registration-section">
      <div className="registration-cards">
        {registrationData.map((registration, index) => (
          <RegistrationCard
            key={index}
            title={registration.title}
            description={registration.description}
            image={registration.image}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default RegistrationSection;


